import { HeroBanner } from '../../components';
import { NavigationMenu, NavigationMenuMobile } from '../../components';
import SEO from '../../components/SEO';
import { seoData } from '../../data/seoData';

const HomePage = () => {
  return (
    <>
      <SEO
        title={seoData.home.title}
        content={seoData.home.content}
        keywords={seoData.home.keywords}
        canonical={seoData.home.canonical}
        ogImage={seoData.home.ogImage}
        ogType={seoData.home.ogType}
        structuredData={seoData.home.structuredData}
      />
      <div style={{ backgroundColor: 'var(--neutral-white)' }}>
        <HeroBanner />
        <NavigationMenu refs={null} textColor='#ffffff' />
        <NavigationMenuMobile textColor='#ffffff' />
      </div>
    </>
  );
};

export default HomePage;
